package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val OrangeColorVariant = ColorVariant(
    n100 = Color(0xFFFFF3EB),
    n200 = Color(0xFFFEDEC8),
    n300 = Color(0xFFFEC195),
    n400 = Color(0xFFFEA362),
    n500 = Color(0xFFF38A3F),
    n600 = Color(0xFFE56910),
    n700 = Color(0xFFC25100),
    n800 = Color(0xFFA54800),
    n900 = Color(0xFF702E00),
    n1000 = Color(0xFF38291E)
)
